"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinkArea = exports.AreaContainer = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const react_router_dom_1 = require("react-router-dom");
exports.AreaContainer = styled_components_1.default.div `
  cursor: pointer;
`;
const LinkArea = ({ children, path, }) => {
    const navigate = (0, react_router_dom_1.useNavigate)();
    return ((0, jsx_runtime_1.jsx)(exports.AreaContainer, Object.assign({ onClick: () => {
            navigate(path);
        } }, { children: children })));
};
exports.LinkArea = LinkArea;
